import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = {
  data: null,
  active: false,
  modalOpen: false,
  openModal() {},
  closeModal() {},
};

export const AnnouncementProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/announcement`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive) setData(d && d.is_active ? d : null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const value = {
    data,
    active: !!data,
    modalOpen,
    openModal: () => setModalOpen(true),
    closeModal: () => setModalOpen(false),
  };

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useAnnouncement = () => useContext(Ctx) || FALLBACK;
